/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var remove = require( 'fs' ).unlink;


// MAIN //

/**
* Asynchronously removes a directory entry.
*
* @param {(string|Buffer|integer)} path - entry path
* @param {Function} clbk - callback to invoke after removing a directory entry
*
* @example
* function done( error ) {
*     if ( error ) {
*         throw error;
*     }
* }
*
* unlink( './beep/boop.txt', done );
*/
function unlink( path, clbk ) {
	remove( path, clbk );
}


// EXPORTS //

module.exports = unlink;
